var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33505 13.712V12.416L5.74305 11.264L8.33505 10.112V8.816L4.01505 10.832V11.696L8.33505 13.712ZM10.2066 14.72L13.0866 7.232H11.7906L8.91056 14.72H10.2066ZM13.6654 13.712L17.9854 11.696V10.832L13.6654 8.816V10.112L16.2574 11.264L13.6654 12.416V13.712Z",
    fill: "black",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    stroke: "black",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbed);
export default __webpack_public_path__ + "static/media/embed.42771c21.svg";
export { ForwardRef as ReactComponent };